/* globals ENV:true window  __webpack_public_path__:true */ // eslint-disable-line no-unused-vars

// Dynamically define public path
__webpack_public_path__ = // eslint-disable-line camelcase
  ((window || global || {}).__ENV__ || {}).PUSHBOT_WEB_PATH ||
  ENV.PUSHBOT_WEB_PATH ||
  '/';

require('./util/polyfills')
  .default()
  .then(polyfills => require('./configure')); // eslint-disable-line no-unused-vars



// WEBPACK FOOTER //
// ./js/index.js